import {useEffect, useState} from 'react';
import {Route, Switch, useRouteMatch} from 'react-router-dom';
import Error from '../common/Error';
import Container from '../common/layout/Container';
import {useAppDispatch} from '../../store/hooks';
import {MatchParams} from '../../constants/types';
import useFetch from '../../hooks/useFetch';
import {setTitle} from '../../store/header/header.slice';
import Tabs from '../common/Tabs';
import permissionsInfo from '../../constants/permissionsInfo';
import Spinner from '../common/Spinner';
import Profile from './Profile';
import Processes from './PatientProcesses';

const getTabs = (path: string) => ([
  {
    name: 'Profile',
    link: path,
    permissions: permissionsInfo.patients.view
  },
  {
    name: 'Processes',
    link: `${path}/processes`,
    permissions: permissionsInfo.patients.processes.view
  }
]);

const EditPatient = () => {
  const dispatch = useAppDispatch();
  const {url, params}: MatchParams = useRouteMatch();
  const {id} = params || {};
  const [fullName, setFullName] = useState('');

  const [data, isLoading, error] = useFetch(`/patients/${id}`);

  useEffect(() => {
    dispatch(setTitle('Patients'));
  }, []);

  useEffect(() => {
    setFullName(`${data?.firstName || ''} ${data?.lastName || ''}`);
  }, [data]);

  if (error) {
    return <Error message={error} />;
  }

  return (
    <Container header="Patients">
      {isLoading ?
        (<Spinner loadingText="Getting patient info" />) :
        (<>
          <h2 className="subheader">Edit Patient - {fullName}</h2>
          <Tabs tabs={getTabs(url)} />

          <Switch>
            <Route exact path={url}>
              <Profile id={id} apiData={data} setPatientName={setFullName}/>
            </Route>

            <Route exact path={`${url}/processes`}>
              <Processes id={id}/>
            </Route>
          </Switch>
        </>)}
    </Container>
  );
};

export default EditPatient;
